import { useId } from "react";

import { cn } from "@/lib/utils";

export default function DragonBg({
  className,
  ...props
}: React.ComponentProps<"svg">) {
  const a = useId();
  const b = useId();
  const c = useId();
  const d = useId();
  const e = useId();
  const f = useId();
  const g = useId();
  const h = useId();
  const i = useId();
  const j = useId();
  const k = useId();

  return (
    <svg
      aria-hidden="true"
      className={cn("h-[243px] w-full", className)}
      fill="none"
      viewBox="0 0 340 243"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M156.165 79.382s32.706 0 93.732-16.271c6.152-1.64 15.403-7.492 26.652-6.424 11.24 1.072 14.158 5.78 14.158 5.78s4.994-2.568 11.24-2.568c6.247 0 16.244 5.351 16.244 5.351 14.092-27.453 30.738-35.13 57.7-30.187 26.963 4.944 30.157 29.115 30.157 29.115s8.843-4.233 15.304-3.267c7.491 1.123 6.353 7.763 6.353 7.763s27.064-.216 42.994 5.246c0 0-.94-19.085 38.115-11.377 0 0 28.583-48.781 78.284-45.904 47.683 2.759 51.298 45.904 51.298 45.904s21.55-2.708 29.98 0c8.431 2.707-2.81 11.377-2.81 11.377s25.292-4.174 42.788-4.174c17.495 0 19.358 9.636 19.358 9.636s16.861-3.534 21.863-3.212c4.994.322 9.997 3.212 9.997 3.212H156.165Z"
        fill="#fff"
        fillOpacity={0.6}
        fillRule="evenodd"
        opacity={0.5}
        style={{
          mixBlendMode: "soft-light",
        }}
      />
      <path
        clipRule="evenodd"
        d="m-637.572 38.358 39.526.113 315.486.917 63.241.184 128.684.373 31.085.09 17.518.052 66.685.189 25.325.075a236.363 236.363 0 0 0-18.775-3.103c-35.827-4.479-66.191-.36-76.369 1.355-2.372.402-3.656.671-3.656.671s-1.228-1.497-4.616-3.156c-2.739-1.36-6.931-2.825-13.044-3.67-10.262-1.422-20.75-.024-27.06 1.186-3.657.704-5.901 1.346-5.901 1.346s.889-2.04 1.313-4.493c.536-3.122.296-6.92-3.544-8.026-6.832-1.97-15.626 0-15.626 0s-11.731-13.94-40.077-16.066c-27.103-2.027-48.842 1.766-50.691 2.107-.085.009-.127.018-.127.018-.127-.108-.254-.222-.382-.33a40.675 40.675 0 0 0-2.061-1.687c0-.01-.028-.023-.042-.033a55.75 55.75 0 0 0-5.872-3.944c-12.366-7.238-25.174-15.082-54.903-13.259-40.401 2.476-52.48 22.168-52.48 22.168-46.019-6.765-81.691 5.57-81.691 5.57s-18.563-2.253-36.166 2.258c-9.43 2.414-12.959 6.618-14.201 10.006a9.602 9.602 0 0 0-.607 2.858c-.523-.671-1.595-1.347-3.642-1.829-.029-.009-.071-.018-.113-.028-5.873-1.327-15.641-.529-15.641-.529v-.01c-12.737-21.351-46.18-21.673-55.992-21.854-27.484-.51-40.126 10.918-59.254 18.576-6.973 2.787-12.295 5.192-15.189 6.548-1.623.75-2.484 1.18-2.484 1.18-13.707-4.312-28.657 4.177-28.657 4.177Z"
        fill="#fff"
        fillOpacity={0.7}
        fillRule="evenodd"
        opacity={0.3}
        style={{
          mixBlendMode: "soft-light",
        }}
      />
      <path
        clipRule="evenodd"
        d="M116.035 176.656a31.49 31.49 0 0 0 1.583-.596c2.367 7.136 10.26 21.407 22.897 21.407.856 2.928 3.163 8.782 5.545 8.782.792 0 .177.117-1.189.377-3.765.715-13.23 2.513-14.686 5.936-9.26-2.745-26.986-4.721-23.811 9.331-17.995.606-58.344-2.26-75.773-18.576 10.492 12.438 47.163 36.486 109.914 33.169 10.778 6.205 37.624 12.852 58.789-10.202 9.26-.949 26.854-6.87 23.15-22.967-4.63-20.121-12.567-41.528-64.158-43.724-4.189-4.574-16.8-12.075-33.733-5.488-1.764-3.202-7.871-8.783-18.189-5.489-3.728-6.676-14.178-15.728-28.554-4.952l6.46 11.06 28.421 15.502 3.334 6.43Z"
        fill="#fff"
        fillOpacity={0.07}
        fillRule="evenodd"
        opacity={0.9}
        style={{
          mixBlendMode: "soft-light",
        }}
      />
      <path
        d="M213.143 96.58c7.126 20.819-5.279 28.045-11.41 29.202l-4.312 12.573c22.627-5.622 30.847-32.087 21.01-44.314-8.466-10.522-33.543-14.295-48.518-23.212-4.521-2.692-9.104-8.163-5.968-12.389.417-.562.842-1.064 1.102-1.668.717-1.667-.298-4.783-.895-6.133 1.791 6.201-2.707 2.825-3.101 4.134-.316 1.047.131 3.157.394 4.081-5.387 22.31 46.368 22.157 51.698 37.726Z"
        fill="#4D0D54"
      />
      <path
        d="M196.985 107.039c-6.813 9.085-25.106 15.921-33.401 18.204l23.715 4.008c12.758-9.39 21.425-9.775 31.731-1.169 6.847-8.35 10.02-22.045 24.717-24.216 2.138-19.64 11.468-30.562 15.865-33.568-2.939-13.761 10.371-25.035 13.21-27.485-20.074 1.385-46.833 7.556-57.132 11.285L197.987 67.96c2.505 9.24 5.812 29.994-1.002 39.079Z"
        fill={`url(#${a})`}
      />
      <path
        clipRule="evenodd"
        d="M232.038 49.481c-8.815 12.444-15.471 25.495-21.246 36.816-9.719 19.056-16.938 33.21-27.738 31.32l.003-.038c5.65-2.939 10.913-6.519 13.929-10.54 6.814-9.085 3.507-29.838 1.002-39.08L215.69 54.1c3.691-1.337 9.495-2.987 16.348-4.618Z"
        fill="#DE6924"
        fillRule="evenodd"
      />
      <path
        d="M206.451 65.497c8.922-2.673 33.57-5.245 53.422 4.985M205.102 69.081l9.95 2.839c2.735.78 5.222 2.254 7.169 4.328 8.154 8.691 20.564 23.024 22.023 29.167"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.058}
      />
      <path
        d="m150.709 138.256.852-7.599 5.999 5.149-2.649 7.649c-2.84 1.079-14.293-1.714-19.542-3.713l-1.087 3.352a.522.522 0 0 1-1.017-.16v-3.928l-4.381-.671a.61.61 0 0 1 .154-1.212l3.827.383-2.751-3.194a.577.577 0 0 1 .805-.819l3.796 3.163 1.781-2.805a.398.398 0 0 1 .71.35l-1.046 2.855c4.721.264 12.691.834 14.549 1.2Z"
        fill={`url(#${b})`}
      />
      <path
        d="m150.709 138.256.852-7.599 5.999 5.149-2.649 7.649c-2.84 1.079-14.293-1.714-19.542-3.713l-1.087 3.352a.522.522 0 0 1-1.017-.16v-3.928l-4.381-.671a.61.61 0 0 1 .154-1.212l3.827.383-2.751-3.194a.577.577 0 0 1 .805-.819l3.796 3.163 1.781-2.805a.398.398 0 0 1 .71.35l-1.046 2.855c4.721.264 12.691.834 14.549 1.2Z"
        fill={`url(#${c})`}
      />
      <path
        d="m203.032 111.355-31.752 15.506h-10.338c13.457-4.889 40.507-15.159 41.056-17.131.548-1.971.918-14.9 1.034-21.118v-8.123c2.835 3.545 3.249 22.054 3.101 30.866h-3.101Z"
        fill="#4D0D54"
      />
      <path
        d="m204.543 70.392 8.872 12.088c.682.93 1.275 1.92 1.669 3.004 3.482 9.602 6.768 33.101 3.817 42.447"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.058}
      />
      <path
        d="M148.62 76.92c1.388 2.294 5.809 4.426 7.845 5.206v2.79c-6.095-1.93-7.769-6.135-7.845-7.995Z"
        fill="#4D0D54"
      />
      <path
        d="M127.104 96.529c3.048 12.628 15.422 25.824 21.228 30.844l3.82 6.062c-3.326-1.646-11.067-5.665-15.421-8.567-5.443-3.629-8.87-9.677-12.7-12.398-3.064-2.177-8.669-.504-11.088.605-5.079-20.481-12.8-26.811-16.026-27.416-2.257-22.013-7.996-32.153-10.583-34.47 2.661-10.564-1.109-20.798-3.326-24.594 14.595 6.612 27.516 17 32.153 21.368l11.943 16.995c-1.271 5.262-3.049 18.942 0 31.57Z"
        fill={`url(#${d})`}
      />
      <path
        clipRule="evenodd"
        d="M132.973 109.501c-2.636-4.15-4.813-8.595-5.869-12.973-3.049-12.628-1.27-26.308 0-31.57l-11.943-16.995c-1.959-1.846-5.397-4.766-9.815-8.022 2.892 6.54 7.978 20.042 7.978 28.295 0 8.647 13.151 32.246 19.726 42.964l-.077-1.699Z"
        fill="#DE6924"
        fillRule="evenodd"
      />
      <path
        d="M121.381 61.44c-4.876-4.7-18.831-13.3-35.64-10.108M122.625 64.264h-3.1c-4.115 0-8.106 1.53-10.924 4.529-4.509 4.797-9.96 11.42-11.94 16.65M122.761 65.92c-2.192 2.9-6.631 8.96-6.85 10.002-.274 1.301-3.631 16.92-2.809 39.732"
        stroke="#fff"
        strokeLinecap="round"
        strokeWidth={1.058}
      />
      <path
        d="m121.581 102.319 1.262-25.79 1.814 1.813-.868 22.715c.505 2.019 10.832 12.461 15.932 17.43l3.312 4.89c-3.848-2.019-14.433-14.144-19.244-19.954l-2.208-1.104Z"
        fill="#4D0D54"
      />
      <path
        clipRule="evenodd"
        d="M148.332 127.373c-5.806-5.02-18.18-18.216-21.228-30.844-3.049-12.629-1.271-26.309 0-31.57l-11.943-16.996c-.18-.17-.373-.349-.577-.536l8.036 18.779c-1.076 4.099-1.936 15.945 3.225 30.54 4.989 14.111 16.63 27.599 23.774 32.669l-1.287-2.042Z"
        fill="#872A81"
        fillRule="evenodd"
      />
      <path
        d="M135.845 113.937c3.909 4.886 9.714 6.224 12.129 6.282 2.385 3.781 6.354 11.943 2.166 9.779-4.188-2.164-11.357-11.99-14.295-16.061Z"
        fill="#872A81"
      />
      <path
        d="M164.127 78.162c.644 2.095.268 4.05 0 4.767l1.678 1.611c.161-3.867-1.052-5.863-1.678-6.378Z"
        fill="#4D0D54"
      />
      <path
        clipRule="evenodd"
        d="M166.911 124.247c9.134-2.934 24.066-9.196 30.074-17.207 6.814-9.085 3.508-29.838 1.002-39.08L215.69 54.1c.291-.106.593-.214.906-.324-.93 2.727-3.933 6.473-6.626 9.834-1.86 2.322-3.573 4.459-4.353 5.948-.774 1.477-1.013 5.166-1.316 9.845-.535 8.252-1.269 19.58-5.485 27.267-5.001 9.12-23.163 15.393-31.905 17.577Z"
        fill="#872A81"
        fillRule="evenodd"
      />
      <path
        d="M186.944 115.404c-22.384 11.878-26.53 6.532-28.691 4.65l3.321 7.228s-1.038 6.479 8.302 0 17.068-11.878 17.068-11.878Z"
        fill="#872A81"
      />
      <path
        d="M190.614 154.733c-3.002-1.225-6.663-5.003-8.118-6.739 1.852-1.223 5.988-3.423 7.716-2.439 2.16 1.229 4.925 5.742 5.283 7.736.286 1.595 2.517 3.655 3.597 4.486l-1.179 12.004h1.808a.992.992 0 0 1 .358 1.917l-1.659.642.131 3.522a.897.897 0 1 1-1.793.034v-2.859l-3.035 3.537a1.124 1.124 0 1 1-1.694-1.482l1.506-1.689h-3.093a.753.753 0 0 1-.077-1.501l5.07-.526s.626-11.148-.379-12.89l-.025-.044c-.988-1.711-1.44-2.494-4.417-3.709Z"
        fill={`url(#${e})`}
      />
      <path
        d="M190.614 154.733c-3.002-1.225-6.663-5.003-8.118-6.739 1.852-1.223 5.988-3.423 7.716-2.439 2.16 1.229 4.925 5.742 5.283 7.736.286 1.595 2.517 3.655 3.597 4.486l-1.179 12.004h1.808a.992.992 0 0 1 .358 1.917l-1.659.642.131 3.522a.897.897 0 1 1-1.793.034v-2.859l-3.035 3.537a1.124 1.124 0 1 1-1.694-1.482l1.506-1.689h-3.093a.753.753 0 0 1-.077-1.501l5.07-.526s.626-11.148-.379-12.89l-.025-.044c-.988-1.711-1.44-2.494-4.417-3.709Z"
        fill={`url(#${f})`}
      />
      <path
        d="M167.971 92.586c-.596-.794-.248-2.261 0-2.564h-5.377l.744 3.97 9.513 3.805 1.82-1.902c-1.985-.772-6.105-2.515-6.7-3.31Z"
        fill={`url(#${g})`}
      />
      <path
        d="M177.424 95.855c-.335-.388-8.935-3.866-9.712-4.353 2.753 1.376 12.243 4.563 12.951 4.669.884.132.862 1.124.95 1.433.088.31 1.96.84 2.321.509.361-.332-.177-1.348.375-1.967.553-.62.664-.089.995.331.332.42.442.288.803.288.361 0 1.256.132 1.521-.155.265-.287-.512-1.282 0-1.48.511-.2 4.142.512 4.972 1.016.829.504 1.307 1.593 2.232 3.026.925 1.434.355 3.493.289 4-.066.507-1.168.991-1.543.991-.374 0-2.202-.639-2.423-1.19-.22-.551-.75-.815-1.323-.727-.573.088-.022.485 0 .727.022.243-.45.928-2.204.419-1.754-.509-2.491-1.522-2.491-2.051 0-.529-1.212-.97-1.564-.97-.353 0 .462 1.499 0 1.499-.463 0-1.455.442-2.513-.439-1.058-.882-.198-1.014 0-1.5.198-.484-.352-.704-.683-1.013-.331-.309-.551-1.609-.771-1.94-.221-.33-1.764-.638-2.182-1.123Z"
        fill={`url(#${h})`}
      />
      <path
        d="m167.511 91.253-.828-.874c1.551-.68 5.46-.063 6.997.33l-1.678.97-1.111-1.159-1.182.875-1.135-.875-1.063.733ZM165.463 93.343l-1.325.706c-.246 2.95 6.204 3.381 8.699 3.037l-.697-1.028-1.146.692-.419-1.284-1.174.754-.335-1.257-1.341.81-.307-1.48-1.38.67-.575-1.62Z"
        fill="#FFFBFB"
      />
      <path
        clipRule="evenodd"
        d="M214.726 127.513c-2.206 7.484-18.511 26.961-38.667 24.65-23.585-2.705-28.264-23.646-29.247-32.021-2.95-7.157-5.946-23.546 5.662-31.851 1.16-.592 3.418-2.032 3.176-3.06s.202-2.545.454-3.175c0 0 7.124-.603 8.617 0 1.493.603 1.738 1.36 1.738 1.36l3.747 1.815c2.117 1.008 5.894 3.664 5.853 4.309-.121 1.935-2.217 1.864-3.25 1.587-1.965-.353-6.335-.847-8.088 0-1.754.846.428 2.822 1.738 3.704l4.518 1.344a5.316 5.316 0 0 0 3.591-.2l.11-.047c-.185.386-.371.971-.565 1.58-.389 1.22-.808 2.534-1.304 2.538-.288.003-.542-.299-.872-.691-.522-.621-1.235-1.47-2.578-1.7-.729-.127-1.777-.148-2.853-.17-1.513-.03-3.083-.062-3.902-.387-1.401-.555-2.041-2.267-2.041-2.267-3.208 7.705-5.467 24.209 2.697 28.907 10.151 5.842 33.961 4.306 38.481 2.089l1.624 9.113c4.602-2.141 8.371-4.664 11.361-7.427Zm-11.704-2.042c-.464.103-.822.195-1.036.26.33-.069.677-.155 1.036-.26Z"
        fill={`url(#${i})`}
        fillRule="evenodd"
      />
      <path
        d="M163.007 84.429c.479.044.86.266 1.126.511.287.265.13.713-.26.68-.385-.031-.764-.228-1.108-.469-.394-.275-.236-.766.242-.722Z"
        fill="#FFFBFB"
      />
      <path
        clipRule="evenodd"
        d="M169.848 150.928c8.54-2.31 10.771-9.158 10.799-12.384l-.74-.006c-.025 3.018-2.165 9.672-10.633 11.775l.118.478.456.137Zm-10.953-5.811c6.516-1.092 9.693-5.84 10.523-8.492l-.706-.221c-.789 2.521-3.936 7.234-10.548 8.072.239.216.483.43.731.641Zm-6.803-8.269c5.97.453 10.054-2.84 11.567-4.989l-.605-.426c-1.433 2.035-5.456 5.286-11.399 4.631.142.262.288.523.437.784Zm-3.761-9.062c5.702.555 9.777-2.419 11.358-4.433l-.582-.457c-1.481 1.887-5.422 4.776-10.987 4.122.067.254.138.51.211.768Zm-2.317-9.821c5.502 1.807 10.118-.194 12.249-1.906a18.676 18.676 0 0 1-.155-.734l-.052-.058c-1.881 1.664-6.615 3.924-12.316 1.817.09.302.181.595.274.881Zm-1.868-12.33c5.365 3.935 10.918 2.958 13.606 1.653.02-.267.042-.533.067-.799l-.03-.054c-2.364 1.319-8.111 2.604-13.609-1.704-.016.302-.028.603-.034.904Zm38.036 46.634a32.14 32.14 0 0 1-1.464.082l-.062-.132c7.901-3.701 8.713-10.643 8.154-13.61l.727-.137c.575 3.054-.205 9.803-7.355 13.797Zm13.351-3.954c-.583.304-1.177.596-1.781.873 4.999-4.944 4.423-10.835 3.399-13.351l.685-.278c1.013 2.489 1.582 7.89-2.303 12.756Z"
        fill="#4D0D54"
        fillRule="evenodd"
      />
      <path
        clipRule="evenodd"
        d="M147.151 122.229c-.971-8.185 1.549-21.473 11.754-29.75 3.707-3.006 1.443-5.456-.781-7.864-.768-.832-1.532-1.659-2.043-2.501-.255.66-.666 2.12-.431 3.117.242 1.028-2.017 2.469-3.176 3.06-11.608 8.305-8.612 24.695-5.663 31.851.076.646.188 1.345.34 2.087Z"
        fill={`url(#${j})`}
        fillRule="evenodd"
      />
      <path
        d="M160.916 90.56c-2.062-1.961-6.668-5.899-8.599-5.959-2.414-.075 1.508 8.297 8.599 5.96Z"
        fill="#FFFBFB"
      />
      <path
        clipRule="evenodd"
        d="M204.454 134.387c.83-1.655 1.383-3.229 1.695-4.571-1.557-4.033-3.541-4.362-4.339-4.023-4.339 2.236-28.346 3.818-38.551-2.055-3.268-1.88-4.865-5.653-5.401-9.995-.095 5.919 1.124 12.851 5.147 17.975.462 3.253 1.939 8.846 5.212 11.929-1.467 2.608-3.86 7.482-4.48 8.865-.342.762-2.669 3.763-3.964 5.125l-1.308-1.496a.573.573 0 0 0-.885.724l1.112 1.452-3.707 1.07a.507.507 0 0 0 .207.991l3.5-.459-1.832 2.783a.614.614 0 0 0 .954.763l3.174-3.295 2.28 1.327a.555.555 0 0 0 .67-.876l-2.337-2.304 9.351-9.389a8.506 8.506 0 0 0 2.215-8.105l-.702-2.751c1.362.409 2.842.71 4.448.885a52.772 52.772 0 0 0 14.583-.44c1.575 1.821 3.643 3.517 6.225 4.467l2.89 2.89.991 11.314h-2.048a.429.429 0 0 0-.212.802l1.028.581-3.945 1.022a.872.872 0 0 0 .382 1.701l3.735-.713-1.066 2.861a.958.958 0 0 0 1.785.693l1.206-2.979 1.134 2.517a.83.83 0 0 0 1.56-.548l-1.239-4.81 1.066-13.319c-1.117-.959-3.469-3.379-3.938-5.383-.189-.809-.405-2.093-.615-3.477a39.527 39.527 0 0 0 4.019-1.749Z"
        fill={`url(#${k})`}
        fillRule="evenodd"
      />
      <defs>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={a}
          x1={218.203}
          x2={218.203}
          y1={42.813}
          y2={129.251}
        >
          <stop stopColor="#E76823" />
          <stop offset={1} stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={b}
          x1={147.007}
          x2={142.963}
          y1={115.422}
          y2={143.656}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={c}
          x1={142.963}
          x2={141.775}
          y1={132.986}
          y2={143.562}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#C83EBF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={d}
          x1={117.58}
          x2={117.58}
          y1={26.595}
          y2={133.435}
        >
          <stop stopColor="#E76823" />
          <stop offset={1} stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={e}
          x1={194.255}
          x2={164.117}
          y1={107.863}
          y2={161.861}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={f}
          x1={191.704}
          x2={182.087}
          y1={151.015}
          y2={173.063}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#C83EBF" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={g}
          x1={168.632}
          x2={168.632}
          y1={90.022}
          y2={97.797}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#872A81" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={h}
          x1={184.554}
          x2={168.932}
          y1={94.916}
          y2={93.909}
        >
          <stop stopColor="#E76823" />
          <stop offset={1} stopColor="#F9B651" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={i}
          x1={175.88}
          x2={215.568}
          y1={81.788}
          y2={166.363}
        >
          <stop stopColor="#BA3491" />
          <stop offset={1} stopColor="#D2573D" />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={j}
          x1={154.396}
          x2={147.456}
          y1={88.505}
          y2={122.384}
        >
          <stop stopColor="#792374" />
          <stop offset={1} stopColor="#872A81" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          gradientUnits="userSpaceOnUse"
          id={k}
          x1={180.383}
          x2={170.57}
          y1={122.849}
          y2={162.292}
        >
          <stop stopColor="#4D0D54" />
          <stop offset={1} stopColor="#C83EBF" />
        </linearGradient>
      </defs>
    </svg>
  );
}
